import FeatureGates from '@atlaskit/feature-gate-js-client';
import { AidFrontendFeatureGate } from '../../../../providers/FeatureGates';
import { checkFeatureGate } from '../../../../utilities/feature-flags/feature-gate';
import { AnalyticsClient } from '../../../../utilities/analytics/analytics-web-client';

type ApplicationData = {
  coreApplication: string;
  experience?: string;
};

export const triggerTWCG786AATestPrioritiseSSO = ({
  applicationData,
  analyticsClient,
}: {
  applicationData?: ApplicationData;
  analyticsClient: AnalyticsClient | undefined;
}) => {
  try {
    if (checkFeatureGate(AidFrontendFeatureGate.TWCG_786_AA_TEST_PRIORITISE_SSO)) {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.pathname === '/login') {
        const cohortValue = FeatureGates.getExperimentValue(
          'twcg-786-aa-test-prioritise-sso',
          'cohort',
          'not-enrolled'
        ) as 'variation' | 'control' | 'not-enrolled';

        analyticsClient?.trackingEvent({
          page: 'login-page',
          action: 'exposed',
          subject: 'twcg-786-aa-test-prioritise-sso',
          attributes: {
            flagKey: 'twcg-786-aa-test-prioritise-sso',
            group: cohortValue,
            application: applicationData?.coreApplication,
            experience: applicationData?.experience,
          },
        });
      }
    }
  } catch (error) {
    analyticsClient?.operationalEvent({
      page: 'login-page',
      action: 'failed',
      subject: 'twcg-786-aa-test-prioritise-sso',
      attributes: {
        flagKey: 'twcg-786-aa-test-prioritise-sso',
        application: applicationData?.coreApplication,
        experience: applicationData?.experience,
        errorName: error?.name,
        errorStack: error?.stack,
        errorMessage: error?.message,
        errorCode: error?.code,
      },
    });

    console.error('Error checking TWCG786AATestPrioritiseSSOEnabled', error);
  }
};
